module.exports = __webpack_public_path__ + "static/img/home_icon_earn_3.baed666.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/home_icon_earn_3.png
// module id = vsNI
// module chunks = 0